module.exports = "/fonts/dripicons-v2.eot?7e12564e72400735ae5b671780f6a9f7";